import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ForceTrailingSlash() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const path = location.pathname;
        const hasSlash = path.endsWith("/");

        if (!hasSlash) {
            const search = location.search || "";
            const hash = location.hash || "";
            navigate(`${path}/${search}${hash}`, { replace: true });
        }
    }, [location, navigate]);

    return null;
}